// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3qAqm","description":"PatientConsentPreview_description__2wCMh"};